/**
 * Funzioni helper per ottenere valori default delle impostazioni
 * Questi vengono usati quando non ci sono impostazioni personalizzate dell'utente
 */
import { TERMINAL_DATA } from '../constants/terminalConstants';
import { SEZIONI, SEZIONI_AWG } from '../constants/cableConstants';
import { COLOR_MAP, COLORI_MAPPINGS } from '../constants/colorConstants';
import { EW3035_ADVANCED_SETTINGS_DEFAULTS, EW3035_MACHINE_SETTINGS_DEFAULTS } from '../machines/EW-3035+L';
import { sanitizeTerminalData } from './terminalDataNormalization';

export const getDefaultTerminalData = () => TERMINAL_DATA;

export const mergeTerminalDataWithDefaults = (terminalData = {}) => {
  const sanitizedTerminalData = sanitizeTerminalData(terminalData);

  const merged = {};

  Object.entries(TERMINAL_DATA).forEach(([code, defaultTerminal]) => {
    merged[code] = {
      ...defaultTerminal,
      ...(sanitizedTerminalData[code] || {})
    };
  });

  Object.entries(sanitizedTerminalData).forEach(([code, terminal]) => {
    if (!merged[code]) {
      merged[code] = terminal;
    }
  });

  return merged;
};

export const getDefaultCableSections = () => ({
  SEZIONI,
  SEZIONI_AWG
});

export const getDefaultColorMappings = () => ({
  COLOR_MAP,
  COLORI_MAPPINGS
});

export const getDefaultMachineSettings = () => ({
  enabled: {
    'EW-3035': true,
    'EW-05': false
  },
  machines: {
    'EW-3035': EW3035_MACHINE_SETTINGS_DEFAULTS,
    'EW-05': {}
  }
});

export const getDefaultAppSettings = () => ({
  quantitaCablaggi: 1,
  marcaCavi: 1,
  enableSeparateSingleCableSiglature: false,
  marcaturePerCollegamento: false,
  lingua: 'it',
  lunghezzaPreview: 350,
  useAWG: false,
  ...EW3035_ADVANCED_SETTINGS_DEFAULTS,
});

export const getDefaultCableCatalog = () => ({
  unipolari: [],
  multipolari: []
});

export const getDefaultCable = () => ({
  siglaturaA: '',
  siglaturaB: '',
  useSeparateSiglature: false,
  gruppo: '',
  colore: 'ORANGE',
  sezione: 0.5,
  lunghezza: 200,
  terminaleA: 'PSW',
  terminaleB: 'PSW',
  collegamentoA: '',
  collegamentoB: ''
});

export const getDefaultMultipolarCable = () => ({
  gruppo: '',
  lunghezza: 200,
  nomeCavo: '',
  poli: [
    {
      id: Date.now(),
      colore: 'ORANGE',
      sezione: 0.5,
      siglaturaA: '',
      siglaturaB: '',
      lunghezzaA: 200,
      lunghezzaB: 200,
      terminaleA: 'PSW',
      terminaleB: 'PSW',
      collegamentoA: '',
      collegamentoB: ''
    }
  ]
});
